// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum Roles {
    AccessTestEnvironment = 'accessTestEnvironment',
    AiReports = 'aiReports',
    AreaManagement = 'areaManagement',
    Asphalt = 'asphalt',
    Asphaltcoordinator = 'asphaltcoordinator',
    Asphaltexecutor = 'asphaltexecutor',
    AsphaltPlanningBroer = 'asphaltPlanningBroer',
    Codalt = 'codalt',
    Commerce = 'commerce',
    CompactMachinist = 'compactMachinist',
    Construction = 'construction',
    Consumer = 'consumer',
    CraneMachinist = 'craneMachinist',
    Customer = 'customer',
    CustomerProjectsAccess = 'customerProjectsAccess',
    DirkRead = 'dirkRead',
    DirkWithCode = 'dirkWithCode',
    DirkWithPassword = 'dirkWithPassword',
    Employee = 'employee',
    Executor = 'executor',
    Executors = 'executors',
    FormerEmployee = 'formerEmployee',
    Hourcheck = 'hourcheck',
    HourcheckBuitenGewoon = 'hourcheckBuitenGewoon',
    HourCheckRestricted = 'hourCheckRestricted',
    HoursExtended = 'hoursExtended',
    Hourwriter = 'hourwriter',
    Hrm = 'hrm',
    Kam = 'kam',
    Leave = 'leave',
    LeaveManagement = 'leaveManagement',
    Machinist = 'machinist',
    Management = 'management',
    OtherEmployees = 'otherEmployees',
    Planner = 'planner',
    PlanningAlwaysRead = 'planningAlwaysRead',
    ProjectManagement = 'projectManagement',
    Projectmanager = 'projectmanager',
    StreetGroundTraffic = 'streetGroundTraffic',
    Supplier = 'supplier',
    Traffic = 'traffic',
    TruckDriver = 'truckDriver',
    UserManagement = 'userManagement',
    Uta = 'uta',
    VkmExecutor = 'vkmExecutor',
    VkmMechanic = 'vkmMechanic',
    Wfs = 'wfs',
}
